import React, { useEffect, useState } from "react";
import {
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    } from "../../ui";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import DialpadIcon from '../../ui/icons/Dialpad';
import {
  DELETEREASON,
  isRoleAllowed,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS
} from "../../../constants/constant";
import SnpButton from "../../global/SnpButton";
import NumpadItemSearch from "./NumpadItemSearch";

const BillUtilityButtons = () => {
  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const { billDetails, billDeletedItems } = useSelector((state) => state.bill);
  const [isRoyaltyPointsAllowed, setRoyaltyPointsAllowed] = useState(false);
  const { snackbar, dialog } = useSnpUI();

  useEffect(() => {
    //setRoyaltyPointsAllowed(restoBillConfig.applyRoyaltyPoints);
  }, [restoBillConfig]);

  const shouldShowDeletedBillItems = () => {
    const isDeleteReasonAllowed = getConfigValueByKey(
      restoBillConfig,
      DELETEREASON
    );
    // console.log(
    //   "isDeleteReasonAllowed: ",
    //   isDeleteReasonAllowed,
    //   "billDeletedItems: ",
    //   billDeletedItems);

    return (
      isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) &&
      isDeleteReasonAllowed &&
      billDeletedItems.length !== 0
    );
  };

  const handleShowDeletedItems = () => {
    dialog.show({
      negativeReq: true,
      negativeAction: "Dismiss",
      outSideClickDismiss: true,
      positiveReq: false,
      onSideClickDismiss: true,
      cancelExtra: true,
      requestType: 99,
      gui: buildDelItemDisplayData(billDeletedItems),
    });
  };

  const applyRoyaltyPrice = () => { };
  const buildDelItemDisplayData = (delItems) => {
    return (
      <>
        {!isEmpty(delItems) && (
          <Grid container spacing={2}>
            <Grid item md={12} xs={12} lg={12} sm={12}>
              <Typography
                variant="p"
                style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}
              >
                Previously Deleted Items
              </Typography>
            </Grid>
            <Grid item md={12} xs={12} lg={12} sm={12}>
              <TableContainer component={Paper}>
                <Table aria-label="simple table" className="rate_card">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Item</TableCell>
                      <TableCell align="center">Qty</TableCell>
                      <TableCell align="center">Reason</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.values(delItems).map((singleItems) => {
                      return (
                        <TableRow
                          className="rate_card--row"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="center">
                            <p
                              style={{
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word",
                              }}
                            >
                              {singleItems.name +
                                " " +
                                (!isEmpty(singleItems.foodQuantityName)
                                  ? "(" + singleItems.foodQuantityName + ")"
                                  : "")}
                            </p>
                          </TableCell>
                          <TableCell align="center">
                            {singleItems.quantity}
                          </TableCell>
                          <TableCell align="center">
                            <p
                              style={{
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word",
                              }}
                            >
                              {singleItems.delReason}
                            </p>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const buildNumpadUi = () => {
    return (
      <NumpadItemSearch
        callHide={() => dialog.hide()}
      />
    );
  }

  const handleShowNumpad = () => {
    dialog.show({
      negativeReq: true,
      negativeAction: "Dismiss",
      outSideClickDismiss: true,
      positiveReq: false,
      iconReq: false,
      onSideClickDismiss: true,
      cancelExtra: true,
      requestType: 99,
      gui: buildNumpadUi(),
    });
  };

  return (
    <div className="billing-cust-button-data">
      {isRoyaltyPointsAllowed && (
        <SnpButton
          key="loyalty"
          variant="contained"
          mbgcolor="#ff5800"
          onClick={applyRoyaltyPrice}
        >
          {billDetails.isPointAdded
            ? "Remove Loyalty Price"
            : "Redeem Loyalty Price"}
        </SnpButton>
      )}
      {shouldShowDeletedBillItems() && (
        <SnpButton
          key="delItems"
          variant="contained"
          mbgcolor="#260026"
          sx={{ mr: 2 }}
          onClick={handleShowDeletedItems}
        >
          Show Deleted Items
        </SnpButton>
      )}
      <IconButton>
        <DialpadIcon color="#002600" sx={{
          fontSize: "2rem", color: "#002600"
        }} onClick={() => handleShowNumpad()} />
      </IconButton>
    </div>
  );
};

export default BillUtilityButtons;
